"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = "mdc-toolbar";
exports.SECTION_BASE_CLASS_NAME = exports.BASE_CLASS_NAME + "__section";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/toolbar/lib/constants.js
// module id = ./node_modules/@react-mdc/toolbar/lib/constants.js
// module chunks = 2